// extracted by mini-css-extract-plugin
export var colorSquare = "_n8-0";
export var danger = "_n8-5";
export var lightPink = "_n8-8";
export var neutralBlue = "_n8-7";
export var neutralYellow = "_n8-6";
export var normal = "_n8-1";
export var primary = "_n8-2";
export var primaryLight = "_n8-3";
export var solidBlack = "_n8-g";
export var solidGreen = "_n8-b";
export var solidLightBlue = "_n8-d";
export var solidNavy = "_n8-c";
export var solidOrange = "_n8-f";
export var solidPink = "_n8-e";
export var solidRed = "_n8-9";
export var solidYellow = "_n8-a";
export var success = "_n8-4";